// extracted by mini-css-extract-plugin
var _1 = "Notification_block__b5773";
var _2 = "Notification_closeIcon__245b1";
var _3 = "Notification_closeIconWrapper__18fed";
var _4 = "Notification_content__129c4";
var _5 = "Notification_divider__ada96";
var _6 = "Notification_error__ad6b1";
var _7 = "Notification_icon__373d0";
var _8 = "Notification_info__e46a1";
var _9 = "Notification_list__cb4b9";
var _a = "Notification_message__2b621";
var _b = "Notification_notification__a6caa";
var _c = "Notification_opacity__f508f";
var _d = "Notification_root__c623e";
var _e = "Notification_success__964bf";
export { _1 as "block", _2 as "closeIcon", _3 as "closeIconWrapper", _4 as "content", _5 as "divider", _6 as "error", _7 as "icon", _8 as "info", _9 as "list", _a as "message", _b as "notification", _c as "opacity", _d as "root", _e as "success" }
